module.exports = __webpack_public_path__ + "static/media/startup.c1da6406.png";